import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../../Assets/CSS/Styles.scss";

const CaseStudyDetail = () => {
  const { id } = useParams();
  const [caseStudy, setCaseStudy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`http://localhost:8000/api/blogs/${id}`) // Make sure your backend route matches
      .then((res) => {
        setCaseStudy(res.data);
      })
      .catch((err) => {
        console.error("Error fetching case study:", err);
        setCaseStudy(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date) ? "Unknown date" : date.toLocaleDateString();
  };

  if (loading) return <p className="text-center py-10">Loading case study...</p>;
  if (!caseStudy) return <p className="text-center py-10">No case study available.</p>;

  return (
    <div className="container mx-auto px-6 py-12 max-w-4xl mt60">
     
      {/* Image */}
      {caseStudy.image && (
        <img
          src={`http://localhost:8000/uploads/${caseStudy.image}`}
          alt={caseStudy.title}
          className="w-full h-96 object-cover mb-6 rounded-lg shadow-md"
        />
      )}

       {/* Title */}
      <h1 className="text-4xl font-bold mb-4">{caseStudy.title}</h1>

      {/* Overview */}
      {caseStudy.overview && (
        <p className=" text-gray-700 mb-8">{caseStudy.overview}</p>
      )}

      {/* Author & Date */}
      <p className="text-gray-500 mb-6">
        By {caseStudy.author || "Unknown"} •{" "}
        {caseStudy.publishDate ? formatDate(caseStudy.publishDate) : "No date"}
      </p>


      {/* Sections */}
      {caseStudy.sections?.length > 0 &&
        caseStudy.sections.map((section, index) => (
          <div key={index} className="mb-6 border-b pb-6">
            {section.title && (
              <h2 className="text-2xl font-semibold mb-2">{section.title}</h2>
            )}
            {section.description && (
              <p className="mb-4 text-gray-700">{section.description}</p>
            )}
            {section.points?.length > 0 && (
              <ul className="list-disc ml-6 space-y-1 text-gray-700">
                {section.points.map((point, i) => (
                  <li key={i} dangerouslySetInnerHTML={{ __html: point }}></li>
                ))}
              </ul>
            )}
          </div>
        ))}

      {/* Conclusion if present */}
      {caseStudy.fullContent?.conclusion && (
        <div className="mt-8">
          <h3 className="text-xl font-semibold mb-2">Conclusion</h3>
          <p className="text-gray-700">{caseStudy.fullContent.conclusion}</p>
        </div>
      )}
    </div>
  );
};

export default CaseStudyDetail;
